<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {},
  methods: {},
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}
.el-main {
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
}

.el-table__body-wrapper {
  &::-webkit-scrollbar {
    width: 0px;
    height: 8px;
    // background: red;
    // border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f7f7f7;
  height: 100%;
  overflow-y: none;
}

.el-tooltip__popper {
  max-width: 800px;
  max-width: 52vw;
}

* {
  box-sizing: border-box;
}

.filter-custom {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;

  .label {
    margin-right: 12px;
    font-size: 14px;
  }
}

.table-custom {
  padding: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .downDataToExcel {
    margin-bottom: 20px;
  }

  .pagination {
    margin: 20px;
  }
}

.pagination-custom {
  margin-top: 20px;
}
</style>
